import _ from "lodash";
import { config } from "../../../../../../../../config";

const percentToFloat = (val) => {
  const num = typeof val === "string" ? parseFloat(val) : val;
  return isNaN(num) ? 0 : num / 100;
};

const floatToPercent = (val) =>
  typeof val === "number" ? +(val * 100).toFixed(2) : 0;

export const mapStateToCreatePaymentPlanDto = ({
  masterDevelopers = [],
  secondaryDevelopers = [],
  downPaymentAmountPercentage = 0,
  handoverAmountPercentage = 0,
  installment = [],
  postHandoverInstallment = [],
  paymentPlanName = "",
  description = "",
  paymentTypeId = null,
  propertyPlanStatus = 1,
  isForSpecificProperty = false,
  propertyId = null,
  selectedConfigrationId = null,
  paymentPlanDocuments = [],
  id = null,
  paymentPlanFees = [],
}) => {
  const paymentPlanDevelopers = [
    ...masterDevelopers.map((dev) => ({
      developerId: dev.developerId,
      isSecondary: false,
    })),
    ...secondaryDevelopers.map((dev) => ({
      developerId: dev.developerId,
      isSecondary: true,
    })),
  ];

  const mapInstallments = (arr) =>
    (arr || []).map((item) => ({
      ...item,
      amountPercentage: percentToFloat(item.amountPercentage),
      numberOfInstallment: item.numberOfInstallment
        ? Number(item.numberOfInstallment)
        : 1,
    }));

  const mapFees = (arr) =>
    (arr || []).map((item) => ({
      ...item,
      feeAmount: item.feeAmount ? Number(item.feeAmount) : 0,
    }));

  const mapDocuments = (arr) =>
    (arr || []).map((file) => ({
      fileId: file.fileId,
      fileName: file.fileName,
    }));

  const downPayment =
    downPaymentAmountPercentage > 0
      ? [
          {
            amountPercentage: percentToFloat(downPaymentAmountPercentage),
            installmentTypeId: config.InstallmentTypes.DownPayment,
          },
        ]
      : [];
  const handoverPayment =
    handoverAmountPercentage > 0
      ? [
          {
            amountPercentage: percentToFloat(handoverAmountPercentage),
            installmentTypeId: config.InstallmentTypes.HandoverPayment,
          },
        ]
      : [];

  return {
    paymentPlanName,
    description,
    paymentTypeId,
    propertyPlanStatus,
    isForSpecificProperty,
    propertyId,
    selectedConfigrationId,
    paymentPlanDocuments: mapDocuments(paymentPlanDocuments),
    id,
    paymentPlanDevelopers,
    propertyPlanInstallments: [
      ...mapInstallments(installment),
      ...mapInstallments(postHandoverInstallment),
      ...downPayment,
      ...handoverPayment,
    ],
    paymentPlanFees: mapFees(paymentPlanFees),
  };
};

export const mapActiveItemToState = (activeItem = {}) => {
  const paymentPlanDevelopers = activeItem.paymentPlanDevelopers || [];
  const masterDevelopers = paymentPlanDevelopers.filter((d) => !d.isSecondary);
  const secondaryDevelopers = paymentPlanDevelopers.filter(
    (d) => d.isSecondary
  );

  const installmentsByType = _.groupBy(
    activeItem.propertyPlanInstallments || [],
    "installmentTypeId"
  );

  const downPaymentArr =
    installmentsByType[config.InstallmentTypes.DownPayment] || [];
  const downPaymentAmountPercentage = downPaymentArr[0]
    ? floatToPercent(downPaymentArr[0].amountPercentage)
    : 0;

  const handoverArr =
    installmentsByType[config.InstallmentTypes.HandoverPayment] || [];
  const handoverAmountPercentage = handoverArr[0]
    ? floatToPercent(handoverArr[0].amountPercentage)
    : 0;

  const installment = (
    installmentsByType[config.InstallmentTypes.Installment] || []
  ).map((item) => ({
    ...item,
    amountPercentage: floatToPercent(item.amountPercentage),
    numberOfInstallment:
      item.numberOfInstallment ?? item.installmentNumber ?? 1,
    frequencyValue: item.frequencyValue ?? item.instalmentDate ?? "",
    id: item.id || crypto.randomUUID(),
  }));

  const postHandoverInstallment = (
    installmentsByType[config.InstallmentTypes.PostHandoverInstallment] || []
  ).map((item) => ({
    ...item,
    amountPercentage: floatToPercent(item.amountPercentage),
    numberOfInstallment:
      item.numberOfInstallment ?? item.installmentNumber ?? 1,
    frequencyValue: item.frequencyValue ?? item.instalmentDate ?? "",
    id: item.id || crypto.randomUUID(),
  }));

  const paymentPlanFees = (activeItem.paymentPlanFees || []).map((item) => ({
    ...item,
    id: item.id || crypto.randomUUID(),
    feeAmount: item.feeAmount ? String(item.feeAmount) : "",
  }));

  return {
    propertyPlanStatus: activeItem.propertyPlanStatus ?? 1,
    paymentPlanName: activeItem.paymentPlanName ?? "",
    paymentTypeId: activeItem.planTypeId ?? null,
    description: activeItem.description ?? "",
    isForSpecificProperty: !!activeItem.isForSpecificProperty,
    isForSpecificDeveloper: !!(
      masterDevelopers.length || secondaryDevelopers.length
    ),
    selectedConfigurationId: activeItem.selectedConfigrationId ?? null,
    masterDevelopers,
    secondaryDevelopers,
    paymentPlanDocuments: activeItem.paymentPlanDocuments || [],
    downPaymentAmountPercentage,
    handoverAmountPercentage,
    installment,
    postHandoverInstallment,
    paymentPlanFees,
    propertyId: activeItem.propertyId ?? null,
    id: activeItem.id ?? activeItem.propertyPaymentPlanId ?? null,
  };
};
